



















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { Route } from "vue-router";
import { Authorization, FlowTypesEnum } from "@/services/authorizations/types";
import {
    createAuthorization,
    getAuthorization,
    updateAuthorization,
    getRedirectUri,
    getOAuthJwtToken
} from "@/services/authorizations/authorizationService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import { authorizationValidators } from "@/components/authorizations/authorizationValidators";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import moment from "moment";

@Component<ROPCForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: { UnsavedFormModal, HeaderActionButtons },
    directives: {
        validate
    }
})
export default class ROPCForm extends Vue {
    @Prop() authorizationId!: string;

    // local state
    authorization = {
        id: "",
        credentialsName: "",
        flowType: FlowTypesEnum.AuthorizationCodeFlow,
        url: "https://login.microsoftonline.com/#tenantId/oauth2/v2.0/token",
        authorized: false
    } as Authorization;

    priorAuthorizationState = JSON.parse(JSON.stringify(this.authorization)) as Authorization;
    redirectUri = "";
    externalAuthorizationLink = "";

    i18n = i18n;
    flowTypesEnum = FlowTypesEnum;
    validators = authorizationValidators;
    preventSave = false;
    preventBack = false;
    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    fetchingActive = false;

    // lifecycle hooks
    async created() {
        this.fetchData();
        window.addEventListener("storage", (event) => {
            if (event.storageArea !== localStorage) return;
            if (event.key === "refresh") {
                if (event.newValue === "true") {
                    window.localStorage.setItem("refresh", "");
                    this.fetchData();
                }
            }
        });
        getRedirectUri().then(response => {
            this.redirectUri = response;
        });
    }

    // methods
    fetchData() {
        if (this.authorizationId || this.authorization.id !== "") {
            this.fetchingActive = true;
            getAuthorization(this.authorizationId ? this.authorizationId : this.authorization.id).then(response => {
                this.authorization = response;
                this.authorization.clientSecret = "dummy-secret";
                this.priorAuthorizationState = JSON.parse(JSON.stringify(this.authorization)) as Authorization;
                this.fetchingActive = false;
            });
        }
    }

    async save(back: boolean) : Promise<any> {
        if (this.saveClicked) return;
        this.saveClicked = true;
        if (!await validateForm([this.validators])) {
            this.saveClicked = false;
            return;
        }
        // create or update
        if (this.authorization.id !== "") {
            await updateAuthorization(this.authorization);
            this.saveClicked = false;
            this.priorAuthorizationState = JSON.parse(JSON.stringify(this.authorization));
            if (back) {
                this.$router.push({
                    name: "authorizations"
                });
            }
        } else {
            const id = await createAuthorization(this.authorization);
            this.saveClicked = false;
            this.authorization.id = id;
            this.priorAuthorizationState = JSON.parse(JSON.stringify(this.authorization));
            if (back) {
                this.$router.push({
                    name: "authorizations"
                });
            }
        }
    }

    back() {
        this.$router.push({
            name: "authorizations"
        });
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    async initiateAuthorization(external: boolean) {
        await this.save(false);
        const token = await getOAuthJwtToken(this.authorization.id);
        const authorizationLink = `https://login.microsoftonline.com/${this.authorization.tenantId}/oauth2/v2.0/authorize?
                client_id=${this.authorization.clientId}
                &response_type=code
                &login_hint=${this.authorization.username}
                &redirect_uri=${encodeURI(this.redirectUri)}
                &response_mode=query
                &scope=${encodeURI(this.authorization.scopes)}
                &state=${token}`;

        if (external) {
            this.externalAuthorizationLink = authorizationLink;
        } else {
            this.authPopupWindow(authorizationLink, "Authorize", 500, 700);
        }
    }

    async copyExternalAuthorizeLink() {
        await navigator.clipboard.writeText(this.externalAuthorizationLink);
    }

    authPopupWindow(url: any, title: any, w: any, h: any) {
        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoom + dualScreenTop;
        const newWindow = window.open(url, title,
            `
              scrollbars=yes,
              width=${w / systemZoom},
              height=${h / systemZoom},
              top=${top},
              left=${left}
              `
        );

        if (window.focus && newWindow) newWindow.focus();
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }

    // computed
    get editMode() {
        return !!this.authorization.id;
    }

    // router events
    async onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorAuthorizationState, this.authorization);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }
}
